<template>
  <aside
    class="d-none d-lg-flex flex-column bg-white border-start desktop-sidebar"
    aria-label="Selection details sidebar"
  >
    <div class="p-3 flex-grow-1 overflow-auto">
      <slot />
    </div>
  </aside>
</template>

<script>
export default {
  name: "DesktopSidebar"
};
</script>

<style scoped>
.desktop-sidebar {
  width: 360px;
  max-height: calc(100dvh - 84px);
}
</style>
